<template>
  <tr class="responsive-table__tr" :class="{'noMobileBorderBottom': noMobileBorderBottom}">
    <slot />
  </tr>
</template>

<script>
  export default {
    name: "RtTr",
    props: {
      noMobileBorderBottom: {
        default: false,
        type: Boolean
      }
    }
  }
</script>

<style lang="scss">

</style>
